import { config, moment } from 'data';
import { Paginatable, PaginatedData, PaginatedResponse, Timezonable } from 'types/services';

const preparePaginatableParams = <Type extends Paginatable = Paginatable>(params: Type): Type => {
  const page = params.page ?? 1;
  const size = params.size ?? config.DEFAULT_PAGINATION_LIMIT;

  return {
    ...params,
    page,
    size,
  };
};

const preparePaginatedData = <Type>(response: PaginatedResponse<Type>): PaginatedData<Type> => {
  return {
    list: response.content,
    page: response.pageable.pageNumber,
    size: response.pageable.pageSize,
    total: response.totalElements,
  };
};

const prepareTimezonableParams = <Type>(params: Type & Timezonable): Type & Timezonable => {
  if (!params.timezone) {
    params.timezone = moment.tz(moment.tz.guess()).format('Z');
  }

  return params;
};

export {
  preparePaginatableParams,
  preparePaginatedData,
  prepareTimezonableParams,
};
